import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LogService, ServiceRouter, IAuthorizationService } from '@pershing/pershing-core';
// import { AuthorizationServiceDefinition } from './authorization-service-definition';
@Injectable()
export class NxiAuthorizationService implements IAuthorizationService {

    public roleStore: any[] = null; /* To store the roles */
    private serviceUrl: string;
    constructor(private http: HttpClient, private logService: LogService, private serviceRouter: ServiceRouter, @Optional() @Inject('AppSettings') appSettings: any) {
        // this.serviceUrl = this.serviceRouter.getServiceRouteURL(AuthorizationServiceDefinition.getInstance());
        if (appSettings.entitlementJson) {
            // sessionStorage.setItem('NXI_Entitlements', appSettings.entitlementJson);
            let data = appSettings.entitlementJson;
            this.roleStore = data;
        }
    }

    init() {
        /* Fetch the roles on service initialization */
        // this.fetchUserRoles();
    }
    getRoles(): any { }
    saveRolesToStorage(): any { }
    getRolesFromStorage(): any { }
    removeRolesFromStorage(): any { }
    checkRetrievalStatus(): any { }

    /*
        Fetches user role from server.
        Internal function, not to be invoked by any consumers directly.
        Throws error with appropriate details on failure and resets the roles on failure.
    */
    fetchUserRoles(): any {
        let timeNow = Date.now();
        if (this.roleStore) {
            return;
        }
        /*
            If we reach here, it means either this is first request or
            we cleaned up local data and refreshing the roles data from server.
        */
        this.http.get(this.serviceUrl + '?time=' + timeNow, { responseType: 'json' })
            .subscribe((data: any) => {
                if (typeof data !== undefined && data.response !== undefined &&
                    data.response.Entitlements !== undefined &&
                    data.response.Entitlements.length !== undefined) {
                    // sessionStorage.setItem('NXI_Entitlements', data.response.Entitlements);
                    this.roleStore = data.response.Entitlements;
                    this.logService.info('AuthorizationService : Fetching the user roles - SUCCESS');
                    return true;
                } else {
                    // Set the _rolesStore to NULL as the method may be called multiple times
                    this.roleStore = null;
                    return false;
                }
            },
                error => {
                    this.roleStore = null;
                    return false;
                });
        return true;
    }

    /*
        A setRoles() method was not implemented as no external entity should be
        able to overwrite the roles data.
    */
    /*
        Below method is what should be used by the any of the consumers.
        This would take an entitlement expression as input, parse the expression
        and evaluate it to return the status.
    */

    isEntitled(roleExpression: string): boolean {
        /*
        The expressions passed to this method are expected to be have
        a space between every operator and role value.
        Below are some samples:
            role1 && role2
            role1 || ( role2 && role3 )
            ( role1 && role2 ) || (role3 && role4 ) && ! role5
            Every operator must be separated by a space as shown above.
            This is to keep the parsing logic simple enough.
            where role1 and role2 would be like 461.allowRead.
            If the action (like 'allowRead') is missing, then by default, it will be taken as 'allowRead'.
            TODO: Find a better parsing/evaluation solution.
        */
        if (roleExpression && (roleExpression === 'ANY')) {
            return true;
        }
        let element: any;
        let roleElement: any;
        let operatorArray: string[] = ['&&', '||', '!', '(', ')', '((', '))'];
        let roleExpressionArray: string[];
        let roleExpressionArrayLength: number;
        let entIdentifier: string;
        // let entOperation: string; // Unused as the response structure is changed. will be cleaned up later.
        if (roleExpression && (roleExpression.length > 0)) {
            roleExpressionArray = roleExpression.split(' ');
            roleExpressionArrayLength = roleExpressionArray.length;
        } else {
            return false;
        }
        if (roleExpressionArrayLength === 1) {
            if (roleExpressionArray[0].length === 0) {
                return false;
            }
            roleExpression = '( ' + roleExpression + ' )';
            roleExpressionArray = roleExpression.split(' ');
        }
        for (element in roleExpressionArray) {
            if (operatorArray.indexOf(roleExpressionArray[element]) === -1) {
                // Below is the updated piece of code
                entIdentifier = roleExpressionArray[element];
                roleElement = this.roleStore.find(item => item === entIdentifier);
                if (roleElement === undefined) {
                    roleExpressionArray[element] = 'false';
                } else {
                    roleExpressionArray[element] = 'true';
                }
            }
        }
        // tslint:disable:no-eval  // Disabled until an expression evaluation solution is integrated
        return eval(roleExpressionArray.join(''));
    }

    /*
        Cleans up the local roles data.
    */
    cleanUp(): void {
        this.roleStore = null;
    }
}
